import { useAuth } from 'hooks';
import { Button, Heading, ModalContent, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from '../styles';

interface Props {
  closeModal: () => void;
  submitForm: () => Promise<any>;
  isSubmitting: boolean;
}

export function ConfirmReturnModal({
  closeModal,
  submitForm,
  isSubmitting,
}: Props) {
  const { user } = useAuth();
  const { isAdmin } = user;

  return (
    <ModalContent handleClose={closeModal}>
      <S.ModalContentWrapper>
        <S.ModalContent>
          <Heading as="h3" weight={FontWeight.bold} size={FontSize.font16}>
            Confirmar devolução?
          </Heading>

          <Text size={FontSize.font12}>
            Ao confirmar essa devolução o estorno será feito automaticamente.{' '}
            <b>Essa ação é irreversível.</b>
          </Text>
        </S.ModalContent>

        <S.ButtonsWrapper>
          <Button
            type="button"
            variant="outline-secondary"
            onClick={closeModal}
            disabled={isAdmin || isSubmitting}
          >
            Cancelar
          </Button>

          <Button
            type="button"
            variant="danger"
            full
            onClick={submitForm}
            disabled={isAdmin}
            isLoading={isSubmitting}
          >
            Confirmar devolução
          </Button>
        </S.ButtonsWrapper>
      </S.ModalContentWrapper>
    </ModalContent>
  );
}
